import { useTranslation } from "@shared/utils/internationalization";
import { useMemo } from "react";
import range from "lodash/range";
import Box from "@ui-kit/layout/Box/Box.web";
import Select from "@ui-kit/form/Select/Select.web";
import { CartQuantitySelectProps } from "./CartQuantitySelect.props";

const CartQuantitySelect = ({
  id,
  minSelectionAmount,
  maxSelectionAmount,
  amountSelected,
  setAmountSelected,
  disabled,
}: CartQuantitySelectProps) => {
  const { t } = useTranslation("purchases");

  const availQuantities = useMemo(
    () =>
      range(minSelectionAmount, maxSelectionAmount + 1).map((num) => ({
        id: num,
        name: `${num}`,
      })),
    [minSelectionAmount, maxSelectionAmount]
  );

  return (
    // CartQuantityButtons uses bold but is a smaller font size, this meets it in the middle.
    <Box fontWeight="normal" data-testid="cart-quantity-select">
      <Select
        id={id}
        ariaLabel={t("Select a quantity")}
        variant="secondary"
        items={availQuantities}
        selectedItem={{ id: amountSelected, name: `${amountSelected}` }}
        disabled={disabled}
        onSelectedItemChange={({ selectedItem }) => {
          // Where `id` is the number in the generated array from minSelectionAmount and maxSelectionAmount
          setAmountSelected({ amount: selectedItem.id });
        }}
        componentProps={{
          InputButtonProps: {
            width: "67px",
            height: "29px",
            fontWeight: "inherit",
          },
        }}
      />
    </Box>
  );
};

export default CartQuantitySelect;
